import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-name">Eylül Özatman</h1>
        <p className="header-title">Software Engineer</p>
        <p className="header-description">
          Creating innovative solutions through code and creativity
        </p>
      </div>
    </header>
  );
}

export default Header;